module.exports = __webpack_public_path__ + "img/28_86.0e998a26.png";